
import { supabase } from "@/integrations/supabase/client";
import { Lead } from "@/types";

// Generate intent summary using Claude
export const generateIntentSummary = async (transcript: string): Promise<{
  success: boolean;
  intentScore?: number;
  intentSummary?: string;
  keyPoints?: string[];
  recommendedFollowUp?: string;
  error?: string;
}> => {
  try {
    const { data, error } = await supabase.functions.invoke("generate-summary", {
      body: { transcript },
    });

    if (error) throw error;

    return {
      success: true,
      intentScore: data.intent_score,
      intentSummary: data.intent_summary,
      keyPoints: data.key_points,
      recommendedFollowUp: data.recommended_follow_up
    };
  } catch (error) {
    console.error("Error generating intent summary:", error);
    return {
      success: false,
      error: error instanceof Error ? error.message : "An unknown error occurred"
    };
  }
};

// Analyze a lead to create a personalized approach
export const analyzeLeadForPersonalization = async (
  lead: Lead,
  scriptTemplate: string
): Promise<{
  success: boolean;
  personalizedScript?: string;
  insights?: string[];
  approachRecommendations?: string;
  potentialConcerns?: string;
  error?: string;
}> => {
  try {
    const { data, error } = await supabase.functions.invoke("analyze-lead", {
      body: { lead, scriptTemplate },
    });

    if (error) throw error;

    return {
      success: true,
      personalizedScript: data.personalized_script,
      insights: data.insights,
      approachRecommendations: data.approach_recommendations,
      potentialConcerns: data.potential_concerns
    };
  } catch (error) {
    console.error("Error analyzing lead:", error);
    return {
      success: false,
      error: error instanceof Error ? error.message : "An unknown error occurred"
    };
  }
};
